import Button from "@/common/components/Button"
import GoBackButton from "@/common/components/GoBackButton";
import { useGoBack } from "@/common/hooks/useGoBack"
import { useArchiveEstablishmentLead } from "@/features/establishmentLeadsFunnel/hooks/useArchiveEstablishmentLead"
import { useIsMutating, useQueryClient } from "@tanstack/react-query"

interface LeadHeaderProps {
  establishmentLeadId: string
  display_name?: string
  url?: string
  showArchiveButton?: boolean
  archived_at?: string
  buttons?: JSX.Element
}

export const LeadHeader = ({
  establishmentLeadId,
  display_name,
  url,
  showArchiveButton,
  archived_at,
  buttons,
}: LeadHeaderProps) => {
  const goBack = useGoBack()
  const queryClient = useQueryClient()
  const isMutating = !!useIsMutating()

  const {
    mutate: archiveEstablishmentLead,
    isError: archiveEstablishmentLeadIsError,
  } = useArchiveEstablishmentLead({
    establishmentLeadId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['establishmentLead', establishmentLeadId] })
      goBack({ fallback: '/establishment-leads', searchLastRouteFromFallback: true })
    },
  })

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton
            fallback="/establishment-leads"
            searchLastRouteIgnoringFilters
          />
          {url ? (
            <img
              src={url}
              alt={display_name}
              className="size-10 rounded-full object-cover"
            />
          ) : (
            <div className="size-10 bg-white-800 rounded-full"></div>
          )}
          <p className="text-white-400 font-normal" data-testid="header_establishment_display_name">{display_name}</p>
          {showArchiveButton && (
            <Button
              type="button"
              variant="outline-error"
              onClick={() => archiveEstablishmentLead(archived_at ? 'unarchive' : 'archive')}
              disabled={isMutating}
            >
              {archived_at ? 'Desarquivar' : 'Arquivar'}
            </Button>
          )}
        </div>
        {buttons}
      </div>
      {archiveEstablishmentLeadIsError && (
        <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, cheque os campos e tente novamente</p>
      )}
    </div>
  )
}
